import { BackButton } from "@/components/custom/BackButton"
import { PageTitle } from "@/components/custom/PageTitle"
import { Label } from "@/components/ui/label"

export const CredentialsAppHeader = ({
  appName,
  method,
  iconUrl
}: {
  appName: string,
  method: string
  iconUrl: string
}) => {
  return (
    <>
      <BackButton buttonLink="/credentials" buttonText="Back" />
      <PageTitle title={`${method} ${appName} Credential`} />
      <Label className="flex justify-start mb-4 text-base leading-4 font-semibold text-primary" >
        Application
      </Label>
      <div className="flex flex-row items-center font-normal text-base leading-5 text-primary mb-6">
        <div className="flex flex items-center justify-center rounded-sm border-2 border-border h-12 p-2 mr-4 bg-foreground">
          <img src={iconUrl} className="h-5" />
        </div>
        {appName}
      </div>
    </>
  )
}
